import * as React from 'react';
import { renderEmpty } from '../../common/Render';
import translate from '../../../../locale/translate';

import ISettings from './ISettings';
import IWidgetProps from './IWidgetProps';
import InventoryTable from './InventoryTable';
import { renderChart } from './ChartHelper';


export default class Widget extends React.Component<IWidgetProps, {}> {
    static propTypes = {
        inventory: React.PropTypes.object.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    renderInventoryByContainer(inventory: any, startDate: Date, endDate: Date, settings: ISettings) {
        const containers = inventory.map(container => {
            return (
                <div className="space-xl" key={`inventory-container-${container.containerId}`}>
                    <h3>{container.name}</h3>
                    {(container.inventory) ?
                        <InventoryTable inventoryItem={container.inventory} settings={settings} />
                        : <div>{translate.gettext('No inventory data available.')}</div>}
                </div>
            );
        });

        return containers;
    }

    render() {
        const { inventory, settings, reportSettings } = this.props;

        if (!inventory || !inventory.data || !inventory.data.length) {
            return <div></div>;
        }

        const startDate = new Date(reportSettings.startMs);
        const endDate = new Date(reportSettings.endMs);

        const inventoryServer = inventory.data.filter(container => container.system.isServer) || [];
        const inventoryWorkstation = inventory.data.filter(container => !container.system.isServer) || [];

        let renderedSummary = <div></div>;
        let renderedDataServer = <div></div>;
        let renderedDataWorkstation = <div></div>;

        if (settings.displaySummary) {
            const chartDataSystemTypes = [
                { x: translate.gettext('Workstation'), y: Number(inventoryWorkstation.length) },
                { x: translate.gettext('Server'), y: Number(inventoryServer.length) },
            ];

            // Group container by OS (container.system.osName)
            const containerGroupedByOS = inventory.data.reduce((acc, container) => {
                if (!acc[container.system.osName]) {
                    acc[container.system.osName] = [];
                }
                acc[container.system.osName].push(container);
                return acc;
            }, {});
            const osData = Object.keys(containerGroupedByOS);
            const chartDataOS = osData.map(os => {
                return { x: os, y: containerGroupedByOS[os].length };
            });

            renderedSummary = <div>
                <h2>{translate.gettext('Summary')}</h2>
                <h3>{translate.gettext('System types')}</h3>
                {renderChart(chartDataSystemTypes)}
                <h3>{translate.gettext('Operating systems')}</h3>
                {renderChart(chartDataOS)}
            </div>;
        }
        if (inventoryServer.length) {
            renderedDataServer = this.renderInventoryByContainer(inventoryServer, startDate, endDate, settings);
        }
        if (inventoryWorkstation.length) {
            renderedDataWorkstation = this.renderInventoryByContainer(inventoryWorkstation, startDate, endDate, settings);
        }

        return (
            <div>
                {renderedSummary}
                {(inventoryServer.length) ? <div><h2>{translate.gettext('Server')}</h2>{renderedDataServer}</div> : <div></div>}
                {(inventoryWorkstation.length) ? <div><h2>{translate.gettext('Workstation')}</h2>{renderedDataWorkstation}</div> : <div></div>}
                {(!inventoryServer.length && !inventoryWorkstation.length) ? renderEmpty() : <div></div>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/inventory/listInventory/Widget.tsx